/**
 * @Author: Fannie
 * @Date:   2018-04-25T08:55:02+08:00
 * @Last modified by:

 * @Last modified time: 2018-04-25T08:55:02+08:00
 */
import { Employee } from '../constants/employee-constants.js';
import employeeHome from '../services/Employee/employee-home-service.js';
import applicationCenterService from '../services/Employee/application-center-service.js';
import personalCenter from '../services/Employee/personal-center-service.js';
// import approvalCenter from '../services/Employee/approval-center-service.js';
import myAttendance from '../services/Employee/my-attendance-service.js';
import { message } from 'antd';

//employee home 
//假期、调休剩余时间
export function fetchEmployeeTips (params) {
     return (dispatch) => {
         employeeHome.fetchEmployeeTips(params, (res) => {
             if (res.data) {
             	// console.log(res.data.Object);
                 dispatch({
                     type: Employee.ActionTypes.FETCHEMPLOYEETIPSSUCCESS,
                     payload: {
                         employeeTips: res.data.Object
                     }
                 })
             } else {
             	message.error(res.data.Errors)
                throw new Error(`获取信息失败:${res.data.Errors}`)
             }
         }, (err) => {
             dispatch({
                 type: Employee.ActionTypes.FETCHEMPLOYEETIPSSUCCESS,
                 payload: {
                     err
                }
            })
        })
    }
}
//重要提醒
export function fetchEmployeeImportantTips (params) {
     return (dispatch) => {
         employeeHome.fetchEmployeeImportantTips(params, (res) => {
             if (res.data) {
             	// console.log(res.data);
                 dispatch({
                     type: Employee.ActionTypes.FETCHEMPLOYEEIMPORTANTTIPSSUCCESS,
                     payload: {
                         employeeImportantTips: res.data.Object.Data
                     }
                 })
             } else {
             	message.error(res.data.Errors)
                throw new Error(`获取信息失败:${res.data.Errors}`)
             }
         }, (err) => {
             dispatch({
                 type: Employee.ActionTypes.FETCHEMPLOYEEIMPORTANTTIPSSUCCESS,
                 payload: {
                     err
                }
            })
        })
    }
}
//关闭重要提醒
export function closeEmployeeImportantTip (params,callback) {
    return (dispatch) => {
        employeeHome.closeEmployeeImportantTips(params, (res) => {
            if (res.data) {
                dispatch({
                    type: Employee.ActionTypes.CLOSEMPLOYEEIMPORTANTTIPSSUCCESS,
                    payload: {
                        actionStatus: true
                    }
                })
                callback();
            } else {
                message.error(res.data.Errors)
               throw new Error(`关闭失败:${res.data.Errors}`)
            }
        }, (err) => {
            dispatch({
                type: Employee.ActionTypes.FETCHEMPLOYEEIMPORTANTTIPSSUCCESS,
                payload: {
                    err
               }
           })
       })
   }
}

//申请中心
export function fetchLeaveType (params) {
     return (dispatch) => {
         applicationCenterService.fetchLeaveType(params, (res) => {
             if (res.data) {
                // console.log(res.data.Object);
                 dispatch({
                     type: Employee.ActionTypes.FETCHLEAVETYPESSUCCESS,
                     payload: {
                         employeeLeaveType: res.data.Object
                     }
                 })
             } else {
                message.error(res.data.Errors)
                throw new Error(`获取信息失败:${res.data.Errors}`)
             }
         }, (err) => {
             dispatch({
                 type: Employee.ActionTypes.FETCHLEAVETYPESSUCCESS,
                 payload: {
                     err
                }
            })
        })
    }
}


export function fetchApplicationList(gets = {page: 1}) {
    return dispatch => {
        applicationCenterService.fetchApplicationList(gets, res => {
            // console.log(res.data.Object);
            dispatch({
                type: Employee.ActionTypes.FETCHAPPLICATIONLISTSSUCCESS,
                payload: {
                    applicationPage: res.data.Object.Page,
                    applicationPageSize: res.data.Object.PageSize,
                    applicationTotalPage: res.data.Object.Total,
                    applicationData: res.data.Object.Data,
                    applicationDataStatus: "loaded"
                }
            });
        }, err => {});
    }
}

//个人中心
export function fetchPersonalCenter (params) {
     return (dispatch) => {
         personalCenter.fetchPersonalCenter(params, (res) => {
             if (res.data) {
                console.log(res.data);
                 dispatch({
                     type: Employee.ActionTypes.FETCHPERSONALCENTERSSUCCESS,
                     payload: {
                         personalCenterDetail: res.data,
                         personalEducations:res.data.educations,
                         personalExperiences:res.data.expriences,
                         personalParttimes:res.data.parttimes
                     }
                 })
             } else {
                message.error(res.data.Errors)
                throw new Error(`获取信息失败:${res.data.Errors}`)
             }
         }, (err) => {
             dispatch({
                 type: Employee.ActionTypes.FETCHPERSONALCENTERSSUCCESS,
                 payload: {
                     err
                }
            })
        })
    }
}
//我的薪资
export function fetchMySalary(gets = {page: 1}) {
    return dispatch => {
        personalCenter.fetchMySalary(gets, res => {
            // console.log(res.data.Object);
            dispatch({
                type: Employee.ActionTypes.FETCHMYSALARYSSUCCESS,
                payload: {
                    mySalaryPage: res.data.Object.Page,
                    mySalaryPageSize: res.data.Object.PageSize,
                    mySalaryTotalPage: res.data.Object.Total,
                    mySalaryData: res.data.Object.Data,
                    mySalaryDataStatus: "loaded"
                }
            });
        }, err => {});
    }
}
//我的考勤详情
export function fetchMyAttendanceDetail(gets, callback) {
  return dispatch => myAttendance.fetchMyAttendanceDetail(gets, res => {
    // console.log(res);
    dispatch({
      type: Employee.ActionTypes.FETCHMYATTENDANCEDETAILSUCCESS,
      payload: {
        data: res.data.Object.Data
      }
    });
    if ("function" === typeof callback) {
      callback();
    }
  })
}
//移动端我的考勤
export function fetchMyAttendance(params) {
    return dispatch => {
        myAttendance.fetchMyAttendanceRecords(params, res => {
            // console.log(res.data.Object.Data);
            dispatch({
                type: Employee.ActionTypes.FETCHMYATTENDANCESSUCCESS,
                payload: {
                    myAttendanceData: res.data.Object.Data,
                    myyAttendanceDataStatus: "loaded"
                }
            });
        }, err => {});
    }
}



// WEBPACK FOOTER //
// ./src/actions/employee-actions.js